export enum UiMessages {
  forgotPassword = 'Forgotten your password? Please enter your email address. You will receive an email message with instructions on how to reset your password.',
  forgotPasswordEmailSent = `We’ve emailed you instructions for setting your password if an account exists with the email you entered. You should receive them shortly.
           If you don’t receive an email, please make sure you’ve entered the address you registered with, and check your spam folder.`,
}
